import { useContext } from "react";
import { roomContext } from "../contexts/RoomContext";

export const useWhiteboardRoom = () => {
  const {
    room,
    roomDomain,
    roomUrl,
    pageUrl,
    isPremium,
    enableDappAds,
    sameOriginAds,
    gameCenterDappEnable,
    roomError,
    logoUrl,
    backgroundImageUrl,
    announcementId,
    isLoadingImage,
    pollData,
    pollDataIndex,
    setPollDataIndex,
    notitficationUnreadCount,
    setNotificationUnreadCount,
    resetRoom,
    isOnDefaultRoom,
  } = useContext(roomContext);
  return {
    room,
    roomDomain,
    roomUrl,
    pageUrl,
    isPremium,
    enableDappAds,
    sameOriginAds,
    gameCenterDappEnable,
    roomError,
    logoUrl,
    backgroundImageUrl,
    announcementId,
    isLoadingImage,
    pollData,
    pollDataIndex,
    setPollDataIndex,
    notitficationUnreadCount,
    setNotificationUnreadCount,
    resetRoom,
    isOnDefaultRoom,
  };
};
